import React, { useEffect, useState } from "react";
import UserProfileSetting from "./UserProfileSetting";
import CompanyProfileSetting from "./CompanyProfileSetting";
import PreferencesSetting from "./PreferencesSetting";
import VerifyAccount from "../../main/components/menu/Verify";
import { useSelector } from "react-redux";
import { selectedProfileSetting } from "../../../redux";
import NotificationComponent from "./NotificationComponent";
import PrivacyComponent from "./PrivacyComponent";
import ProfileSidebarComponent from "./ProfileSidebarComponent";
import SharedHeader5 from "../../../Headers/SharedHeader5";
import { User, Building, Settings, Bell, Shield, Lock, CreditCard } from "lucide-react";
import SharedFooter3 from "../../../Footer/SharedFooter3";
import Card from "../../../components/ui/card";
import { useLocation } from "react-router-dom";
import GeneralSetting from "../../professional/components/GeneralSetting";
import SecurityComponent from "./SecurityComponent";
import BillingComponent from "./BillingComponent";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../../../components/LanguageSelector";

const ClientProfileSettings = () => {
    const { t } = useTranslation();
    // const activeSection = useSelector(selectedProfileSetting);
    const [activeSection, setActiveSection] = useState("general");
    const location = useLocation();

    const navItems = [
        // { id: "profile", label: "Profile Settings", icon: User },
        { id: "general", label: t("profileSettings.generalSettings"), icon: Settings },
        { id: "company", label: t("profileSettings.companyDetails"), icon: Building },
        { id: "preferences", label: t("profileSettings.preferences"), icon: Settings },
        { id: "notifications", label: t("profileSettings.notifications"), icon: Bell },
        { id: "privacy", label: t("profileSettings.privacy"), icon: Lock },
        // { id: "security", label: "Security", icon: Shield },
        { id: "billing", label: t("profileSettings.billing"), icon: CreditCard },
    ];

    useEffect(() => {
        if (location.state?.activeSection) {
            setActiveSection(location.state.activeSection);
        }
    }, [location.state]);
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col" style={{ textAlign: "left" }}>
            <SharedHeader5 />

            <div className="flex-1 max-w-7xl mx-auto px-4 py-8 w-full">
                <div className="flex flex-col md:flex-row gap-8">
                    {/* Settings Navigation */}
                    <aside className="md:w-64">
                        <Card color={undefined} className="p-2">
                            <nav className="space-y-1">
                                {navItems.map(item => (
                                    <button
                                        key={item.id}
                                        onClick={() => setActiveSection(item.id)}
                                        className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm
                      ${activeSection === item.id ? "bg-blue-50 text-blue-700" : "text-gray-600 hover:bg-gray-50"}`}>
                                        <item.icon className="h-5 w-5" />
                                        {item.label}
                                    </button>
                                ))}
                            </nav>
                        </Card>

                        {/* Danger Zone (Commented out as per original code) */}
                        {/* <Card className="p-4 mt-6 border-red-200">
              <h3 className="text-sm font-medium text-red-700 mb-4">Danger Zone</h3>
              <Button
                variant="destructive"
                className="w-full justify-start"
                onClick={() => setShowDeleteConfirm(true)}
              >
                Delete Account
              </Button>
            </Card> */}
                    </aside>
                    <div className="flex-1">
                        {activeSection === "profile" && <UserProfileSetting />}
                        {activeSection === "general" && <GeneralSetting />}

                        {activeSection === "preferences" && <PreferencesSetting />}

                        {activeSection === "verify" && <VerifyAccount />}
                        {activeSection === "notifications" && <NotificationComponent />}

                        {activeSection === "privacy" && <PrivacyComponent />}
                        {activeSection === "security" && <SecurityComponent />}
                        {activeSection === "billing" && <BillingComponent />}

                        {activeSection === "company" && <CompanyProfileSetting />}
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-white border-t w-full mt-auto">
                <div className="max-w-7xl mx-auto">
                    <SharedFooter3 />
                </div>
            </footer>
        </div>
    );
};

export default ClientProfileSettings;
